export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const API_RATE_LIMIT_HIT = 'API_RATE_LIMIT_HIT';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const TOKENS_BY_NSL_TOKEN_REQUEST = 'TOKENS_BY_NSL_TOKEN_REQUEST';
export const TOKENS_BY_NSL_TOKEN_SUCCESS = 'TOKENS_BY_NSL_TOKEN_SUCCESS';
export const TOKENS_BY_NSL_TOKEN_FAILURE = 'TOKENS_BY_NSL_TOKEN_FAILURE';



// WEBPACK FOOTER //
// ./src/actions/authConstants.js